import { render, staticRenderFns } from "./PerubahanEkuitas.vue?vue&type=template&id=ce399684"
import script from "./PerubahanEkuitas.vue?vue&type=script&lang=js"
export * from "./PerubahanEkuitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports